import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "common/modal";
import InputField from "common/customInputField";
import Button from "react-bootstrap/Button";
import ImageUpload from "common/imageUpload";
import uploadIcon from "svg/upload.svg";
import ParentLookup from "common/parentLookup";
import { editProgramDetail } from "store/programBuilder/actionCreator";
import { isEmpty } from "lodash";
import { api } from "store/slices/api";
import { toast } from "react-toastify";

export const SaveOrEditProgramForm = ({ programDetails, setProgramDetails }) => {
  const [showParentLookupModal, setShowParentLookupModal] = useState(false);
  const sub = useSelector((state) => state.loggedInUser.sub);
  const { data: employee } = api.useGetEmployeeQuery(sub);

  useEffect(() => {
    const fromUserName =
      isEmpty(programDetails?.fromUserName) && employee?.firstname && employee?.lastname
        ? `${employee?.firstname} ${employee?.lastname}`
        : programDetails.fromUserName;

    const fromUserTitle = isEmpty(programDetails?.fromUserTitle) ? employee?.jobTitle : programDetails.fromUserTitle;
    const fromUserEmail = isEmpty(programDetails?.fromUserEmail) ? employee?.email : programDetails.fromUserEmail;
    const fromUserPhoneNumber = isEmpty(programDetails?.fromUserPhoneNumber)
      ? employee?.phone
      : programDetails.fromUserPhoneNumber;

    setProgramDetails({ ...programDetails, fromUserName, fromUserTitle, fromUserEmail, fromUserPhoneNumber });
  }, [employee]);

  return (
    <>
      <div className="search-form-container__fields form_wrapper">
        <form className="search-form-container__fields__form custom_form_layout w-100 mb-1">
          <div className="d-flex w-100 mb-3">
            <div className="flex-grow-1 me-5">
              <InputField
                type="text"
                label="Customer Name"
                id="customerName"
                placeholder="Enter Customer Name"
                fieldClasses="form-control search-form-container__fields__form-group__item"
                value={programDetails?.customerName ?? ""}
                onChange={(e) => setProgramDetails({ ...programDetails, customerName: e.target.value })}
                isRequired={true}
                maxLength={100}
              />
            </div>
            <ImageUpload
              handleErrorMessage={(err) => err && toast.error(err)}
              imageURL={programDetails.customerLogo}
              defaultIcon={uploadIcon}
              defaultText="Add Customer Logo"
              handleDeleteImage={() => setProgramDetails({ ...programDetails, customerLogo: "" })}
              handleImageStateUpdate={(imageBlob) => setProgramDetails({ ...programDetails, customerLogo: imageBlob })}
              style={{ width: "16rem" }}
            />
          </div>
          <div className="row mb-3">
            <div className="d-flex w-100">
              <Button
                variant="outline-primary"
                className="parent-lookup-btn"
                onClick={() => setShowParentLookupModal(true)}
              >
                Parent Lookup
              </Button>
              <div className="me-3">
                <InputField
                  type="text"
                  label="Parent Number"
                  id="parentNumber"
                  placeholder="Enter Number"
                  fieldClasses="form-control search-form-container__fields__form-group__item"
                  value={programDetails?.parentNumber ?? ""}
                  onChange={(e) => setProgramDetails({ ...programDetails, parentNumber: e.target.value })}
                  maxLength={4}
                />
              </div>
              <div className="flex-grow-1">
                <InputField
                  type="text"
                  label="Parent Name"
                  id="parentName"
                  placeholder="Enter Parent Name"
                  fieldClasses="form-control search-form-container__fields__form-group__item"
                  value={programDetails?.parentName ?? ""}
                  onChange={(e) => setProgramDetails({ ...programDetails, parentName: e.target.value })}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-sm-12 col-md-12 col-lg-12 search-form-container__fields__form-group">
              <div className="form-group">
                <label
                  htmlFor="programDescription"
                  className="laborCode-Modal__fields__form-group__label justify-content-start"
                >
                  <span className="laborCode-Modal__fields__form-group__label--text">Description</span>
                  <span className="required">*</span>
                </label>
                <textarea
                  className="form-control search-form-container__fields__form-group__item search-form-container__fields__form-group__item text-area-large py-20"
                  id="description"
                  placeholder="Enter Description"
                  value={programDetails?.description ?? ""}
                  onChange={(e) => setProgramDetails({ ...programDetails, description: e.target.value })}
                  maxLength={100}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="custom_form_layout mt-4">
              <div className="col-12 d-md-flex search-form-container__fields__form-group">
                <div className="col-12 col-md-6 pe-3">
                  <InputField
                    type="date"
                    label="Expiration Date"
                    id="expirationDate"
                    fieldClasses="form-control search-form-container__fields__form-group__item"
                    value={programDetails?.expirationDate ?? ""}
                    onChange={(e) => setProgramDetails({ ...programDetails, expirationDate: e.target.value })}
                    isRequired={true}
                  />
                </div>
                <div className="col-12 col-md-6">
                  <InputField
                    type="text"
                    label="User Name"
                    placeholder="Enter User Name"
                    id="fromUserName"
                    fieldClasses="form-control search-form-container__fields__form-group__item"
                    value={programDetails?.fromUserName ?? ""}
                    onChange={(e) => setProgramDetails({ ...programDetails, fromUserName: e.target.value })}
                    isRequired={true}
                    maxLength={100}
                  />
                </div>
              </div>
              <div className="col-12 d-md-flex search-form-container__fields__form-group">
                <div className="col-12 col-md-6 pe-3">
                  <InputField
                    type="text"
                    label="Job Title"
                    placeholder="Enter Job Title"
                    id="fromUserTitle"
                    fieldClasses="form-control search-form-container__fields__form-group__item"
                    value={programDetails?.fromUserTitle ?? ""}
                    onChange={(e) => setProgramDetails({ ...programDetails, fromUserTitle: e.target.value })}
                    isRequired={true}
                    maxLength={100}
                  />
                </div>
                <div className="col-12 col-md-6">
                  <InputField
                    type="text"
                    label="Email Address"
                    placeholder="Enter Email ID"
                    id="fromUserEmail"
                    fieldClasses="form-control search-form-container__fields__form-group__item"
                    value={programDetails?.fromUserEmail ?? ""}
                    onChange={(e) => setProgramDetails({ ...programDetails, fromUserEmail: e.target.value })}
                    isRequired={true}
                    maxLength={100}
                  />
                </div>
              </div>
              <div className="col-12 d-md-flex search-form-container__fields__form-group">
                <div className="col-12 col-md-6 pe-3">
                  <InputField
                    type="tel"
                    pattern="[0-9]{3}-[0-9]{2}-[0-9]{3}"
                    label="Phone Number"
                    placeholder="Enter Phone Number"
                    id="fromUserPhoneNumber"
                    fieldClasses="form-control search-form-container__fields__form-group__item"
                    value={programDetails?.fromUserPhoneNumber ?? ""}
                    isRequired={true}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^(\d|\-|\.|\(|\))]/, "").substring(0, 14);
                      setProgramDetails({ ...programDetails, fromUserPhoneNumber: value });
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="row mb-3">
              <div className="d-flex align-items-center">
                <span className="pdfOptions pdf-toggle my-0" style={{ marginRight: 8 }}>
                  <label className="switch">
                    <input
                      type="checkbox"
                      id="order"
                      onChange={(e) => setProgramDetails({ ...programDetails, isCoverLetterAdded: e.target.checked })}
                      checked={programDetails?.isCoverLetterAdded}
                    />
                    <span className="slider round"></span>
                  </label>
                </span>
                <span className="pdfOptions__options--text">Add Cover Letter</span>
              </div>
            </div>
            {programDetails.isCoverLetterAdded && (
              <>
                <div className="col-12 d-md-flex search-form-container__fields__form-group">
                  <div className="col-12 col-md-6 pe-3">
                    <InputField
                      type="text"
                      label="Title"
                      placeholder="Enter Title"
                      id="coverLetterTitle"
                      fieldClasses="form-control search-form-container__fields__form-group__item"
                      value={programDetails?.coverLetterTitle ?? "Multi-Market Floorcovering Program"}
                      onChange={(e) => setProgramDetails({ ...programDetails, coverLetterTitle: e.target.value })}
                      isRequired={true}
                      maxLength={100}
                    />
                  </div>
                </div>
                <div className="col-12 search-form-container__fields__form-group d-md-flex">
                  <div className="col-12 col-md-12">
                    <div className="form-group">
                      <label
                        htmlFor="toData"
                        className="laborCode-Modal__fields__form-group__label justify-content-start"
                      >
                        <span className="laborCode-Modal__fields__form-group__label--text">Created For</span>
                        <span className="required">*</span>
                      </label>
                      <textarea
                        className="form-control search-form-container__fields__form-group__item search-form-container__fields__form-group__item text-area py-10"
                        placeholder="Enter Created For"
                        id="toData"
                        value={programDetails?.toData ?? ""}
                        onChange={(e) => setProgramDetails({ ...programDetails, toData: e.target.value })}
                        maxLength={100}
                      />
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </form>
      </div>
      {showParentLookupModal && (
        <ParentLookup
          modalDisplayCallback={(show) => setShowParentLookupModal(show)}
          parentSelectionCallback={(parentObj) => {
            const { parentNumber, parentName } = parentObj;
            setProgramDetails({ ...programDetails, parentNumber, parentName });
          }}
        />
      )}
    </>
  );
};

const EditProgramDetailsModal = ({ setIsModalOpen }) => {
  const dispatch = useDispatch();
  const { programDetailsData } = useSelector((state) => state.programBuilder);
  const { sub } = useSelector((state) => state.loggedInUser);
  const [programDetails, setProgramDetails] = useState(programDetailsData);

  let submitDisabled =
    [
      programDetails.customerName,
      programDetails.description,
      programDetails.expirationDate,
      programDetails.fromUserName,
      programDetails.fromUserTitle,
      programDetails.fromUserEmail,
      programDetails.fromUserPhoneNumber,
    ].some(isEmpty) ||
    (programDetails.isCoverLetterAdded
      ? [programDetails.coverLetterTitle, programDetails.toData].some(isEmpty)
      : false);

  return (
    <Modal
      title="Edit Program Details"
      saveButtonText="Save"
      closeButtonText="Cancel"
      handleSave={() => {
        dispatch(editProgramDetail({ ...programDetailsData, ...programDetails, updateBy: sub }));
        setIsModalOpen(false);
      }}
      handleCancel={() => setIsModalOpen(false)}
      size="lg"
      isSaveBtnDisabled={submitDisabled}
    >
      <SaveOrEditProgramForm programDetails={programDetails} setProgramDetails={setProgramDetails} />
    </Modal>
  );
};

export default EditProgramDetailsModal;
